function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_\\uB808\\uC774\\uC5B4_1-2",
  "data-name": "\\uB808\\uC774\\uC5B4 1"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M34.7,0L0,20.04v30.29l34.7,20.04,34.7-20.04v-30.29L34.7,0ZM63.66,47.01l-28.95,16.72L5.75,47.01v-23.65L34.7,6.64l28.95,16.72v23.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.84,19.63v5.46l-5.26,3.04v5.48l-5.08,2.93v8.81l26.2,15.13,26.2-15.13v-19.96l-26.22-15.14-15.85,9.38ZM34.7,53.84l-20.45-11.81v-2.16l2.2-1.27,22.33,12.89-4.07,2.35ZM39.78,45.43l-20.45-11.81v-2.17l2.38-1.38,22.33,12.89-4.26,2.46ZM55.16,28.71v2.19l-10.14,6-20.43-11.8v-2.19l10.14-6,20.43,11.8Z"
})));

function SvgJust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.41 70.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJust);
export default __webpack_public_path__ + "static/media/just.35fe0a59.svg";
export { ForwardRef as ReactComponent };